import { render, staticRenderFns } from "./visualizzaDocumenti.vue?vue&type=template&id=3defc624&scoped=true&"
import script from "./visualizzaDocumenti.vue?vue&type=script&lang=js&"
export * from "./visualizzaDocumenti.vue?vue&type=script&lang=js&"
import style0 from "./visualizzaDocumenti.vue?vue&type=style&index=0&id=3defc624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3defc624",
  null
  
)

export default component.exports